const isInvestmentAmountValid = (amount, amountConfig) => {
  const numericAmount = parseFloat(amount);
  if (!amountConfig || !Number.isFinite(numericAmount) || numericAmount <= 0) {
    return false;
  }

  const presetBoxes = [
    ...(amountConfig.investmentBoxes || []),
    amountConfig.diamondClubBox,
  ].filter(Boolean);
  if (presetBoxes.some((box) => parseFloat(box.amount) === numericAmount)) {
    return true;
  }

  const {
    minimumInvestmentAmount = 0,
    maximumInvestmentAmount,
  } = amountConfig.customInvestmentBox || {};
  return numericAmount >= parseFloat(minimumInvestmentAmount || 0)
    && (
      maximumInvestmentAmount == null
      || numericAmount <= parseFloat(maximumInvestmentAmount)
    );
};

export default isInvestmentAmountValid;
